module.exports = __webpack_public_path__ + "img/JEEP-G.d28d1492.jpg";